import { actions } from "./actions";
import { SearchReducer as reducer } from "./reducers";

const key = "search";

export {
  key,
  actions,
  reducer
};
